import { onError } from 'apollo-link-error';

export function oneLoginRedirect() {
  if (window && window.location) window.location.assign(`${window.location.origin}/onelogin`);
}
export const ERROR_LINK = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((e) => console.log('[GraphQL error]:', e) // eslint-disable-line no-console
    );
    throw new Error(JSON.stringify(graphQLErrors));
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`); // eslint-disable-line no-console
    if (networkError.statusCode === 403) {
      return oneLoginRedirect();
    }
    throw networkError;
  }
  throw new Error('An unexpected GQL error occured.');
});

export function getCredentialTypeIdFromUrl() {
  const { pathname } = window.location;
  const pathParts = pathname.split('/');
  const credentialTypeIdIndex = pathParts.indexOf('credential-type');
  return pathParts[credentialTypeIdIndex + 1];
}
